export default "__VITE_ASSET__DrNncRN0__";